var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col",style:({ flex: '1 1 100%' })},[_c('TopRow',{staticClass:"my-2",attrs:{"part":_vm.part,"grouped_by":this.grouped_by}}),_c('BottomRow',{attrs:{"specificConditionText":_vm.part.specificConditionText,"info":_vm.part.info || ''}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }